export const formatDate = (date: Date | Record<string, never> | null | string): string => {
	if (!date) return "N/A";
	const dateObj = new Date(date as string);
	const day = dateObj.getDate();
	const month = dateObj.toLocaleDateString('en-US', { month: 'long' });
	const year = dateObj.getFullYear();
	return `${day} ${month} ${year}`;
};

